<template>
  <svg width="26" height="40" viewBox="0 0 26 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M26 36.1856V40H21.3436L0 19.9811L4.36391 15.8869L26 36.1856Z" fill="currentColor" />
    <path d="M8.69878 11.836L21.3146 0L25.9939 0V3.76599L13.0455 15.9086L8.69878 11.836Z" fill="currentColor" />
  </svg>
</template>
<script lang="ts" setup></script>
